var map = {
	"./images/BUSD.png": [
		670,
		56
	],
	"./images/USDT.png": [
		671,
		57
	],
	"./notifications/error-icon.png": [
		187
	],
	"./notifications/success-icon.png": [
		121
	],
	"./notifications/x.png": [
		672,
		58
	],
	"./svgs/ArrowGreenLeft.svg": [
		673,
		3
	],
	"./svgs/ArrowLeftWhite.svg": [
		674,
		4
	],
	"./svgs/ArrowRedRight.svg": [
		675,
		5
	],
	"./svgs/ArrowTop.svg": [
		676,
		6
	],
	"./svgs/ArrowVerticalBottom.svg": [
		677,
		7
	],
	"./svgs/ArrowVerticalTop.svg": [
		678,
		8
	],
	"./svgs/Buy.svg": [
		679,
		9
	],
	"./svgs/Cancel.svg": [
		680,
		10
	],
	"./svgs/Candles.svg": [
		681,
		11
	],
	"./svgs/Clock-green.svg": [
		682,
		12
	],
	"./svgs/Clock.svg": [
		683,
		13
	],
	"./svgs/Close.svg": [
		684,
		14
	],
	"./svgs/Dashboard.svg": [
		685,
		15
	],
	"./svgs/EN.svg": [
		686,
		16
	],
	"./svgs/Edit.svg": [
		687,
		17
	],
	"./svgs/Exchange.svg": [
		688,
		18
	],
	"./svgs/Exchange_A.svg": [
		689,
		19
	],
	"./svgs/Exchange_B.svg": [
		690,
		20
	],
	"./svgs/Expand.svg": [
		691,
		21
	],
	"./svgs/Graph.svg": [
		692,
		22
	],
	"./svgs/Help.svg": [
		693,
		23
	],
	"./svgs/History.svg": [
		694,
		24
	],
	"./svgs/HordLogo.svg": [
		695,
		25
	],
	"./svgs/InfoIcon.svg": [
		696,
		26
	],
	"./svgs/News.svg": [
		697,
		27
	],
	"./svgs/Notifications.svg": [
		698,
		28
	],
	"./svgs/Options.svg": [
		699,
		29
	],
	"./svgs/Order.svg": [
		700,
		30
	],
	"./svgs/OrderAsc.svg": [
		701,
		31
	],
	"./svgs/OrderDesc.svg": [
		702,
		32
	],
	"./svgs/PairArrowDown.svg": [
		703,
		33
	],
	"./svgs/Search.svg": [
		704,
		34
	],
	"./svgs/Sell.svg": [
		705,
		35
	],
	"./svgs/SellArrowRed.svg": [
		706,
		36
	],
	"./svgs/Settings.svg": [
		707,
		37
	],
	"./svgs/Star.svg": [
		708,
		38
	],
	"./svgs/Sun.svg": [
		709,
		39
	],
	"./svgs/Transactions.svg": [
		710,
		40
	],
	"./svgs/VerticalArrow.svg": [
		711,
		41
	],
	"./svgs/Wallet.svg": [
		712,
		42
	],
	"./svgs/WalletGreen.svg": [
		713,
		43
	],
	"./svgs/WalletRed.svg": [
		714,
		44
	],
	"./svgs/bnb-chain-icon.svg": [
		715,
		45
	],
	"./svgs/champions-pool.svg": [
		716,
		46
	],
	"./svgs/dex.svg": [
		717,
		47
	],
	"./svgs/ethereum-icon-dark.svg": [
		718,
		48
	],
	"./svgs/ethereum-icon.svg": [
		719,
		49
	],
	"./svgs/heth-token-icon.svg": [
		720,
		50
	],
	"./svgs/hord--token.svg": [
		721,
		51
	],
	"./svgs/hord-min-icon.svg": [
		722,
		52
	],
	"./svgs/portfolio.svg": [
		723,
		53
	],
	"./svgs/vdao-icon.svg": [
		724,
		54
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 642;
module.exports = webpackAsyncContext;